import { IEvent } from "./../../../interfaces/event.interface";
import videojs, { VideoJsPlayer } from "video.js";
import BoxManager from "./BoxManager"; // Passe den Pfad an

import "./styles.css"; // Für optionales Styling
import HlsPlayerManager from "./HlsPlayerManager";

const PluginName = "SLPlugin";
const Plugin = videojs.getPlugin("plugin");
const defaults = {};

export interface ISlPluginOptions {
  event: IEvent;
  eventId: string;
  eventUid: string;
}

class PluginTest extends Plugin {
  options: any;

  constructor(player: VideoJsPlayer, options: ISlPluginOptions) {
    super(player);

    //options.eventUid = "nt3ibr";
    // options.eventId = "6798d2a3e957f8f946f8b9a0";
    this.options = videojs.mergeOptions(defaults, options);
    this.player.ready(() => {
      this.player.addClass("PluginTest");

      // Button zur ControlBar hinzufügen
      const controlBar = this.player.getChild("controlBar");

      if (controlBar) {
        // Suche nach der .vjs-control-separator Klasse
        const fullScreenButton = controlBar
          .el()
          .querySelector(".vjs-fullscreen-control");

        if (fullScreenButton?.parentNode) {
          const myButton = controlBar.addChild("button", {
            name: "MyCustomButton",
          });

          // Button-Klasse hinzufügen
          myButton.addClass("vjs-my-custom-button");

          // Klick-Event für den Button hinzufügen
          myButton.el().addEventListener("click", async () => {
            const boxManager = new BoxManager(this.player); // BoxManager für den Player
            const hlsPlayerManager = new HlsPlayerManager(this.player);

            console.log(this.options.event);
            console.log(this.options.event.showSignLanguage);
            console.log(this.options.event.showHlsSignLanguage);
            console.log(this.options.event.signLanguageHlsVideoUri);
            console.log(this.options.event.showHlsSignLanguage &&
              this.options.event.signLanguageHlsVideoUri.length > 0)
            if (
              this.options.event.showHlsSignLanguage &&
              this.options.event.signLanguageHlsVideoUri.length > 0
            ) {
              await hlsPlayerManager.showHlsPlayer(
                this.options.event.signLanguageHlsVideoUri
              );
            } else if (
              !this.options.event.showHlsSignLanguage &&
              this.options.event.showSignLanguage
            ) {
              await boxManager.showGreenBox(this.options);
            } else {
              console.log("no signlanguage props given!");
            }
          });
          // Das tatsächliche HTML-Element des Buttons nehmen
          const myButtonEl = myButton.el();

          // Button als Child der vjs-control-separator Klasse hinzufügen
          fullScreenButton.parentNode.insertBefore(
            myButtonEl,
            fullScreenButton.nextSibling
          );
        } else {
          console.warn("Keine '.vjs-control-separator' gefunden!");
        }
      }

      console.log("PluginTest wurde initialisiert");
    });
  }
}

// Plugin registrieren
videojs.registerPlugin(PluginName, PluginTest);

export default PluginTest;
